import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function PageTitleComponent({ title, children }) {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `ASR-CERTPERS | ${t(title)}`;
  }, [t, title]);

  return children;
}
